import React from "react";

import {
  PageWrapper,
  FooterLogoImage,
  LoginBlock,
  Logo,
  Footer,
  CopyRightText,
  LoginContent,
  MaintenanceLogo,
  FlashHireLogo,
  MaintenanceTitle,
  MaintenanceDescription,
  FlashHireLogoContainer,
} from "./styledComponents";

import { WithTranslation, withTranslation } from "react-i18next";
interface PropTypes extends WithTranslation {}

function Maintenance(props: PropTypes) {
  const { t } = props;

  return (
    <PageWrapper>
      <LoginBlock>
        <FlashHireLogoContainer>
          <FlashHireLogo src="/img/flash-hire.png" alt="Flash Hire" />
        </FlashHireLogoContainer>
        <LoginContent>
          <MaintenanceLogo src="/img/maintenance.png" alt="Maintenance Image" />
          <MaintenanceTitle>
            {t("common:mainTenanceOngoingTitle")}
          </MaintenanceTitle>
          <MaintenanceDescription>
            {t("common:mainTenanceOngoingMessage")}
          </MaintenanceDescription>
        </LoginContent>
      </LoginBlock>
      <Footer>
        <Logo>
          <FooterLogoImage src="/img/logo-tdcx.png" alt="TDCX" />
        </Logo>
        <CopyRightText>
          {t("common:copyrightText", {
            year: new Date().getFullYear(),
          })}
        </CopyRightText>
      </Footer>
    </PageWrapper>
  );
}

export default withTranslation()(Maintenance);
